

import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IShortServiceProvider} from "@/model/shortInterfaces";
import ChipMixin from "@/components/shared/chips/ChipMixin";
import {RawLocation} from "vue-router";
import {IChipStyle, IChipStyles} from "@/model/chipStyleInterfaces";
import OrderChip from "@/components/shared/chips/OrderChip.vue";
import {icons} from "@/plugins/icons";
import {EServiceProviderType} from "@/model/Service/serviceProviderInterfaces";

@Component({
  mixins: [ChipMixin]
})
export default class ServiceProviderChip extends ChipMixin {

  @Prop()
  protected item!: IShortServiceProvider;
  @Prop()
  protected city!: string;
  @Prop({default: true})
  protected withCity!: boolean;

  private static readonly chipStyles: IChipStyles = Object.assign({}, OrderChip.chipStyles, {
    [EServiceProviderType.infocard]: {
      color: 'cyan',
      icon: icons.serviceProviders.types.infocard,
    },
    [EServiceProviderType.infocard_sending]: {
      color: 'cyan',
      icon: icons.serviceProviders.types.infocard_sending,
    },
    [EServiceProviderType.offline]: {
      color: 'gray',
      icon: icons.serviceProviders.types.offline,
    },
    [EServiceProviderType.services]: {
      color: 'cyan',
      icon: icons.serviceProviders.types.services,
    },
    [EServiceProviderType.supermarket]: {
      color: 'cyan',
      icon: icons.serviceProviders.types.supermarket,
    },
    [EServiceProviderType.webview]: {
      color: 'cyan',
      icon: icons.serviceProviders.types.webview,
    },
  })

  public static chipStyleOf(type: EServiceProviderType): IChipStyle {
    return ServiceProviderChip.chipStyles[type] || ServiceProviderChip.chipStyles['unknown'];
  }

  protected get to(): RawLocation {
    return { name: 'serviceProvider', params: { spId: '' + this.itemId }};
  }
  protected get autoIcon(): string {
    return ServiceProviderChip.chipStyleOf((this.item||{}).type as EServiceProviderType).icon;
  }
  protected get spCssClass(): string[] {
    return this.color === "auto" ? [] : this.cssClass;
  }
  protected get spGetColor(): string {
    return this.color === "auto" ? (this.item||{}).color : this.getColor;
  }
  protected get caption(): string|null {
    return this.withCity
      ? null
      : this.city || (this.item||{}).address_town_city || null
    ;
  }
  protected get titleText(): any {
    return this.$t('services.provider.fields.type.values.' + (this.item||{}).type) + ', ' + (this.item||{}).address_town_city;
  }

}

